import Link from "@/compat/link";
import { usePathname } from "@/compat/navigation";
import {
  LayoutDashboard,
  Building2,
  Users,
  FileText,
  Wrench,
  Receipt,
  BarChart3,
  UserCog,
  IndianRupee,
  Bell,
  Settings,
  UserSearch,
} from "lucide-react";
import { cn } from "@/lib/utils";

const items = [
  { href: "/rent", label: "Dashboard", Icon: LayoutDashboard, exact: true },
  { href: "/rent/properties", label: "Properties", Icon: Building2 },
  { href: "/rent/tenants", label: "Tenants", Icon: Users },
  { href: "/rent/vacancy", label: "Vacancy", Icon: UserSearch },
  { href: "/rent/brokers", label: "Brokers", Icon: Users },
  { href: "/rent/agreements", label: "Agreements", Icon: FileText },
  { href: "/rent/payments", label: "Payments", Icon: IndianRupee },
  { href: "/rent/maintenance", label: "Maintenance", Icon: Wrench },
  { href: "/rent/expenses", label: "Expenses", Icon: Receipt },
  { href: "/rent/reports", label: "Analytics", Icon: BarChart3 },
  { href: "/rent/statements", label: "Statements", Icon: FileText },
  { href: "/rent/tds", label: "Tax & Compliance", Icon: Receipt },
  { href: "/rent/reminders/log", label: "Reminders", Icon: Bell },
  { href: "/rent/settings/reminders", label: "Settings", Icon: Settings },
  { href: "/rent/landlord", label: "Profile", Icon: UserCog },
];

export function RentSubNav() {
  const pathname = usePathname();

  function isActive(href: string, exact?: boolean) {
    if (exact) return pathname === href;
    return pathname === href || pathname.startsWith(href + "/");
  }

  return (
    // `min-w-0` is what makes the `overflow-x-auto` actually work: this nav is
    // a flex item, and a flex item's default `min-width: auto` sizes it to its
    // widest content — so the row of `shrink-0 whitespace-nowrap` links grew
    // the whole rent section past its column instead of scrolling inside it
    // (a horizontal scrollbar on every rent page under the desktop rail).
    <nav className="-mx-2 flex min-w-0 flex-nowrap items-center gap-1 overflow-x-auto px-2 pb-0.5 scrollbar-none">
      {items.map(({ href, label, Icon, exact }) => {
        const active = isActive(href, exact);
        return (
          <Link
            key={href}
            href={href}
            className={cn(
              "flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-[9px] border px-3 py-1.5 text-[12.5px] font-semibold transition-colors",
              active
                ? "border-[var(--cp-accent-wash)] bg-[var(--cp-accent-wash)] text-[var(--cp-accent-ink)]"
                : "border-transparent text-[var(--cp-ink-2)] hover:bg-[var(--cp-surface-2)] hover:text-[var(--cp-ink)]",
            )}
          >
            <Icon className="h-4 w-4" />
            {label}
          </Link>
        );
      })}
    </nav>
  );
}
